import { useEffect, useMemo, useState } from "react";
import { IItemProps } from "devextreme-react/form";

import { ILogger } from "@ezhou/common";
import { PageProps } from "@ezhou/core";

import { getMappingDimensions } from "../../services/mappingDimensionService";

import { OrganizationChildCrudDataGrid } from "../common/OrganizationChildCrudDataGrid";

import {
  dummyMappingRuleTypeSettingDimensionOptionRow,
  mappingRuleTypeSettingDimensionOptionColumns,
} from "./model/metaData";

export type MappingRuleTypeSettingDimensionOptionsProps = {
  parentKey: any;
  pageProps: PageProps;
  logger: ILogger;
};

export const MappingRuleTypeSettingDimensionOptions = (props: MappingRuleTypeSettingDimensionOptionsProps) => {
  const baseUrl = "mapping-rule-type-setting-dimension-options";
  const dataKey = "mappingRuleTypeSettingDimensionOptionId";

  const [mappingDimensionNames, setMappingDimensionNames] = useState<string[]>();

  const dataToBeFiltered = [
    "mappingRuleTypeSetting",
    "mappingDimension",
    "ruleType",
  ];

  const dataToBeFilteredForForm = [dataKey];

  useEffect(() => {
    const fetchMappingDimensionValues = async () => {
      try {
        const httpClient = props.pageProps.appUtil.httpClients["eAccountingService"];
        const values = await getMappingDimensions(httpClient, props.parentKey.organizationId);
        setMappingDimensionNames(values.map(v => v.mappingDimensionName));
      } catch (error) {
        props.logger.error("Failed to fetch mapping dimension values", error);
      }
    };
    fetchMappingDimensionValues();
  }, [props.parentKey.organizationId, props.pageProps.appUtil.httpClients, props.logger]);

  const editorItemOptions = useMemo(() => new Map<string, IItemProps>([
    [
      "mappingDimensionName",
      {
        editorType: "dxSelectBox",
        editorOptions: {
          items: mappingDimensionNames,
          searchEnabled: true,
        },
      },
    ],
    [
      "debitUseAlternativeValueFormula",
      {
        editorType: "dxCheckBox",
      },
    ],
  ]), [mappingDimensionNames]);

  return (
    <>
      <div>Dimension Options</div>
      <OrganizationChildCrudDataGrid
        pageProps={props.pageProps}
        logger={props.logger}
        dummyRow={dummyMappingRuleTypeSettingDimensionOptionRow}
        keyExpr={dataKey}
        isKeyAutoGenerated={true}
        baseUrl={baseUrl}
        parentKey={props.parentKey}
        dataToBeFiltered={dataToBeFiltered}
        formTitle="Add Dimension Option"
        formColCount={2}
        formColSpan={2}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        dataToBeFilteredForForm={dataToBeFilteredForForm}
        hideColumnChooser={true}
        hideSearchPanel={true}
        hideInactiveButton={true}
        columnConfigs={mappingRuleTypeSettingDimensionOptionColumns}
        editorItemOptions={editorItemOptions}
      />
    </>
  );
};
